
import React, { useState, useEffect, useRef } from "react";
import { getDatabase, ref, get, onValue, update } from "firebase/database";
import { useNavigate, useLocation } from "react-router-dom";
import Lottie from "react-lottie-player";
import app from "../../../firebaseConfig";

import rayoazul from './assets/lottie/rayoazul.json';

import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import Alertadenegado from "../alertadenegado"; // Ajusta la ruta según tu estructura
import { FaBars, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";

import "react-toastify/dist/ReactToastify.css";

import { motion } from "framer-motion"; // Importamos framer-motion

import { cacheImage } from "../../../utils/cacheImage";

// Función para mezclar un array aleatoriamente (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
  return array
    .map((item) => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item);
};

function PantallaPrincipal() {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const location = useLocation();
  const navigate = useNavigate(); // Inicializamos navigate
  const { categoria, mesa } = location.state || {}; // Obtener valores del estado
  const [productos, setProductos] = useState([]);
  
    const [categorias, setCategorias] = useState([]);

    const [mostrarBusqueda, setMostrarBusqueda] = useState(false);
  
    const toggleBusqueda = () => {
      setMostrarBusqueda(!mostrarBusqueda);
    };
  

  // Arreglo de animaciones disponibles
const animacionesDisponibles = [
  lineasblancasvolando,
  efectoparticulas,
  fuegoamarillo,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  neutron,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  fuegorojo,
  fuegoamarillo,
];

  const [mostrarAnimacion, setMostrarAnimacion] = useState(true);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  const [denegado, setDenegado] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

    const [activeCategory, setActiveCategory] = useState(null);

    const categoryRefs = useRef({});
    const categoriasRef = useRef(null);

  // helper para generar ids/keys sin espacios
  const slugify = (str) =>
    String(str)
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");
  
  
    const handleCategoriaClick = (categoriaNombre) => {
      const slug = slugify(categoriaNombre);
      const el = categoryRefs.current[slug] || document.getElementById(`cat-${slug}`);
      if (!el) return;
    
      // intentar detectar el header/top nav si existe (ajusta selector si tu nav tiene otra clase/id)
      const headerEl =
        document.querySelector(".top-nav") ||
        document.querySelector("header") ||
        document.querySelector("#navbar") ||
        null;
    
      const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 80; // fallback 80px
      const extraOffset = 12; // ajuste fino (margen)
      const top = window.scrollY + el.getBoundingClientRect().top - headerHeight - extraOffset;
    
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    
      // opcional: marcar como activa (para cambiar estilo)
      setActiveCategory(slug);
    };

// TTL del cache en ms (ej. 30 minutos)
const CACHE_TTL_MS = 1000 * 60 * 30;

const saveCache = (key, data) => {
  try {
    const payload = { ts: Date.now(), data };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (e) {
    // localStorage puede llenarse; ignorar errores silenciosamente
    console.warn("saveCache fallo para", key, e);
  }
};

const loadCache = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (!ts || Date.now() - ts > CACHE_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch (e) {
    console.warn("loadCache fallo para", key, e);
    return null;
  }
};

const clearCacheKey = (key) => {
  try { localStorage.removeItem(key); } catch(e) {}
};
/////////////////////////////////////////////////////////////////////////////////////////


     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);
//////////////////////////////////////////////////////////////////////
// Categoria - Lista de Productos
useEffect(() => {
  if (!categoria) return;
  let abort = false;
  const cacheKey = `productos_categoria_${categoria}`;

  async function cargarProductosPorCategoria() {
    // 1) intentar cargar desde cache
    const fromCache = loadCache(cacheKey);
    if (fromCache && !abort) {
      setProductos(fromCache);
      // lanza cacheImage en background para completar imgCached si hace falta
      fromCache.forEach((p) => {
        if (!p.imgCached && (p.Img || p.Visuales)) {
          const imgUrl = p.Img || (p.Visuales && Object.values(p.Visuales).find(v => v?.tipo === 'imagen')?.url);
          if (imgUrl) {
            cacheImage(imgUrl, p.id).then((u) => {
              if (abort) return;
              setProductos((prev) => {
                if (!prev) return prev;
                const updated = prev.map((it) => (it.id === p.id ? { ...it, imgCached: u || it.imgCached } : it));
                saveCache(cacheKey, updated);
                return updated;
              });
            }).catch(()=>{});
          }
        }
      });
      // retornamos para evitar doble lectura a firebase (si quieres forzar refresh comenta el return)
      return;
    }

    try {
      const db = getDatabase(app);
      const productosRef = ref(db, `nature/Awoo/Categorias/${categoria}`);
      const snapshot = await get(productosRef);
      if (!snapshot.exists()) {
        setProductos([]);
        saveCache(cacheKey, []);
        return;
      }
      if (abort) return;

      const productosData = snapshot.val();
      const lista = [];

      for (const key of Object.keys(productosData)) {
        if (abort) break;
        const prod = productosData[key];
        if (!prod) continue;

        // respetar visibilidad
        const esVisible = (prod.visibilidad?.toLowerCase() === "si") || (prod.Visibilidad?.toLowerCase() === "si");
        if (!esVisible) continue;

        // no esperamos imagenes: ponemos imgCached null por ahora
        const productoProcesado = { id: key, ...prod, imgCached: null };
        lista.push(productoProcesado);
      }

      // guardar y mostrar lo mínimo de inmediato
      if (!abort) {
        setProductos(lista);
        saveCache(cacheKey, lista);
      }

      // ahora cachear imágenes en background y actualizar estado y cache cuando lleguen
      const promesasImgs = lista.map(async (p) => {
        try {
          const imgUrl = p.Img || (p.Visuales && Object.values(p.Visuales).find(v => v?.tipo === 'imagen')?.url);
          if (!imgUrl) return null;
          const u = await cacheImage(imgUrl, p.id);
          if (abort) return null;
          // actualizar estado
          setProductos((prev) => {
            if (!prev) return prev;
            const updated = prev.map((it) => (it.id === p.id ? { ...it, imgCached: u || it.imgCached } : it));
            // actualizar cache con la nueva url de imagen
            saveCache(cacheKey, updated);
            return updated;
          });
          return u;
        } catch (e) {
          return null;
        }
      });

      // no esperamos todas las imágenes para mostrar UI (ya tenemos productos),
      // pero dejamos que el browser las procese en background
      Promise.all(promesasImgs).catch(() => {});
    } catch (err) {
      if (!abort) console.error("Error cargando productos por categoria:", err);
    }
  }

  cargarProductosPorCategoria();
  return () => { abort = true; };
}, [categoria]);


////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
////////////////////////

/////////////////////// Por si se ve en CEL LOGICA DE REDIMENSION
const [esMovil, setEsMovil] = useState(false);

// Detectar si es pantalla pequeña
useEffect(() => {
  const manejarResize = () => {
    setEsMovil(window.innerWidth < 600);
  };

  manejarResize(); // Ejecutar en el primer render
  window.addEventListener("resize", manejarResize);
  return () => window.removeEventListener("resize", manejarResize);
}, []);
///////////////////////////////////////////////


//Codigo para cargar categorias
useEffect(() => {
  let abort = false;
  async function cargarCategorias() {
    // 1️⃣ Intentar cargar desde cache
    const key = "categoriasAwoo_v2";
    const fromCache = loadCache(key);
    if (fromCache) {
      setCategorias(fromCache);
      // no return: también lanzamos una actualización en background para refrescar si hay cambios opcional.
    }

    try {
      const db = getDatabase(app);
      const categoriasRef = ref(db, "nature/Awoo/Categorias");
      const snapshot = await get(categoriasRef);
      if (!snapshot.exists()) return;
      if (abort) return;

      const categoriasData = snapshot.val();
      const categoriasArray = Object.keys(categoriasData);
      const resultado = [];

      for (const categoria of categoriasArray) {
        if (abort) break;
        const visibleSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
        const visible = visibleSnapshot.exists() ? visibleSnapshot.val().toLowerCase() : "no";
        if (visible !== "si") continue;

        const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
        const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";

        // Intentamos cachear la imagen (esto puede tardar) — lo hacemos no bloqueo
        let imgCached = imgUrl || "";
        if (imgUrl) {
          cacheImage(imgUrl, "cat_" + categoria).then((u) => {
            // actualizamos estado y cache cuando termine
            setCategorias((prev) => {
              if (!prev) return prev;
              const updated = prev.map((c) => (c.nombre === categoria ? { ...c, img: u || imgUrl } : c));
              saveCache(key, updated);
              return updated;
            });
          }).catch(()=>{});
        }

        resultado.push({ nombre: categoria, img: imgCached });
      }

      const mezcladas = resultado.sort(() => 0.5 - Math.random());
      if (!abort) {
        setCategorias(mezcladas);
        saveCache(key, mezcladas);
      }
    } catch (err) {
      if (!abort) console.error("Error cargando categorias:", err);
    }
  }

  cargarCategorias();
  return () => { abort = true; };
}, []);

//////////////////////////////////////////////////////////////////////////////////////////////////////


// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};
  // Función para navegar a 3dfyrionvista.js
  const verProducto = (producto) => {
    navigate("/3dfyrionvista", {
      state: { categoria, producto, mesa }, // Enviamos categoría y producto
    });
  };



  if (!animacionSeleccionada) return null; // Muestra nada mientras se selecciona la animación
////////////////////////////////////////////////////////////////////////////////////


////////////////// 🚫 Si el acceso está denegado, solo muestra el AlertDialog
if (denegado) {
  return (
    <Alertadenegado
      open={true}
      onClose={() => {
        setDenegado(false);
        navigate(-1); // Regresa a la página anterior o redirige donde necesites
      }}
    />
  );
}
///////////////////////////


  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };

  return (

<div style={{ display: 'flex', height: '100vh', overflowX: "hidden",maxWidth: "100%",  background: 'black', // Fondo degradado blanco a azul
      position: 'relative', // Necesario para posicionar el contenido y la animación de fondo
      }}>



  {/* Contenido deslizable */}
  <div
    style={{
      flex: 1, // Esto asegura que ocupe todo el espacio disponible arriba de la barra
    }}
  >
    {/* Aquí va todo el contenido deslizable */}
    <div style={{ width:'100%'}}>



{/* ------------------ BARRA LATERAL ------------------------ */}
<motion.div
  initial={{ x: "-100%" }}
  animate={{ x: menuAbierto ? 0 : "-100%" }}
  transition={{ duration: 0.3, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    zIndex: 9999,
    padding: "20px",
    boxShadow: "4px 0 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  }}
>
  {/* Botón cerrar */}
  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      onClick={() => setMenuAbierto(false)}
      style={{
        background: "none",
        border: "none",
        color: "white",
        fontSize: "26px",
        cursor: "pointer",
      }}
    >
      ✖
    </button>
  </div>

  {/* Opciones principales */}
  <div style={{ marginTop: "10px", marginBottom: "20px" }}>
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
      <div
        key={opcion}
        onClick={() => {
          if (opcion === "INICIO") navigate("/");
          if (opcion === "PRODUCTOS") navigate("/3dfyrioninicioproductos");
          if (opcion === "SIMULADORES") navigate("/3dfyrioninicionosotros");
          setMenuAbierto(false);
        }}
        style={{
          padding: "12px 0",
          paddingLeft: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: "pointer",
          borderBottom: "1px solid #333",
        }}
      >
        {opcion}
      </div>
    ))}
  </div>

  {/* Categorías visibles */}
  <div style={{ marginTop: "10px" }}>
    <h3 style={{ fontSize: "14px", color: "#bbb", marginBottom: "10px" }}>
      CATEGORÍAS
    </h3>

    {categorias.map((cat, index) => (
      <div
        key={index}
        onClick={() => {
          handleCategoriaClick(cat.nombre);
          setMenuAbierto(false);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0",
          cursor: "pointer",
          borderBottom: "1px solid #222",
          gap: "10px",
        }}
      >
        <img
          src={cat.img}
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "6px",
            objectFit: "cover",
          }}
        />
        <span style={{ fontSize: "15px" }}>{cat.nombre}</span>
      </div>
    ))}
  </div>
</motion.div>

{/* Fondo oscuro cuando menú está abierto */}
{menuAbierto && (
  <div
    onClick={() => setMenuAbierto(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9998,
    }}
  ></div>
)}
{/* ---------------------------------------------------------- */}


  {/* Encabezado */}
  <div
      style={{
        width: "100%",
        height: "70px",
        backgroundColor: "#111",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Lado izquierdo - botón de menú y logo + lupa */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginLeft: "15px",
        }}
      >
        
      {/* <FaBars size={35} style={{ cursor: "pointer" }} /> */}
      <FaBars 
  size={35} 
  style={{ cursor: "pointer" }} 
  onClick={() => setMenuAbierto(true)}
/>

        
        <img
          src="images/dragonfondo2.png"
          alt="Logo"
          style={{
            height: "75px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        <FaSearch
          size={20}
          style={{ cursor: "pointer" }}
          onClick={toggleBusqueda}
        />
      </div>

      {/* Centro - barra de búsqueda */}
      {mostrarBusqueda && (
        <input
          type="text"
          placeholder="Buscar..."
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50%",
            height: "35px",
            borderRadius: "8px",
            padding: "0 15px",
            border: "none",
            outline: "none",
            fontSize: "16px",
          }}
        />
      )}

      {/* Lado derecho - carrito + contador + perfil */}
{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      position: "relative",
      width: "48px",
      cursor: "pointer",
      marginRight:"19px"
    }}
  >
    <div
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        border: "3px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "45%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 5px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}
    </div>




      {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
      }}
    >
    </div>



     
    <div
    style={{
      position: 'relative', // Asegura que el contenido esté en una capa superior
      width:'100%'
    }}
  >
 
    {/* Animación */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // Alinea los elementos en los extremos
        alignItems: "center", // Centra verticalmente
        position: "relative", // Mantiene posiciones relativas
      }}
    >
      {/* --- Logo y Animación --- */}
      <div
        style={{
          marginLeft: "28px",
          display: "flex",
          alignItems: "center", // Centra verticalmente
          position: "relative",
        }}
      >
        <Lottie
          animationData={animacionSeleccionada}
          play
          loop
          style={{
            position: "absolute",
            width: "400px",
            height: "400px",
            top: "-50px",
            left: "-50px",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />
      </div>





    </div>












{/* Sección de Productos */}
{/* -- Titulo Productos */}
<div
  style={{
    display: "flex",
    alignItems: "center", // Alinea elementos verticalmente
    gap: "10px", // Espacio entre elementos
    marginBottom: "20px",
    textAlign: "left",
    marginLeft: "15px",
    marginTop: "-10px",
    color: "white",
  }}
  
>
    
          <div
            style={{
              display: "flex",
              marginTop: "15px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "150px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#000000", fontSize: "15px" }}>{"🚀 Productos"}</strong>
            <div
              style={{
                marginLeft: "auto", // Empuja el conteo al lado derecho
                padding: "5px 10px",
                backgroundColor: "#26e9f6",
                borderRadius: "15px",
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {"+"}
            </div>
          </div>


           <div
            style={{
              display: "flex",
              marginTop: "15px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              marginLeft: "10px",
              backgroundColor: "#5abe18",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "140px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#fff", fontSize: "15px" }}>{categoria}</strong>
        
          </div>


</div>
{/* -- CARDVIEWS Productos */}
<div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2px 0",
      }}
    >
      <div 
        style={{
          width: "90%",
          borderRadius: "15px",
          padding: "15px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          maxWidth: "90%",
          overflow: "hidden",
        }}
      >
        {/* Contenedor de tarjetas con Grid */}
        <div 
          style={{ 
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "10px",
            justifyContent: "center",
            paddingBottom: "10px",
          }}
        >
          {/* Renderizar productos dinámicamente */}
          {productos
  .filter((producto) => producto.visibilidad === "Si")
  .map((producto) => {
    const tienePrecioAnterior =
      producto.PrecioAnterior !== null &&
      producto.PrecioAnterior !== undefined &&
      producto.PrecioAnterior !== 0;

    const porcentajeDescuento = tienePrecioAnterior
      ? Math.round(
          100 - (producto.Precio * 100) / producto.PrecioAnterior
        )
      : null;

    return (
      <div
        key={producto.id}
        onClick={() => verProducto(producto.Titulo)}
        style={{
          backgroundColor: "#fff",
          borderRadius: "15px",
          padding: "10px",
          textAlign: "center",
          border: "3px solid #02f2fa",
          boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
          cursor: "pointer",
          position: "relative", // ← importante para posicionar el label
        }}
      >
        {/* Imagen del producto */}
        <div style={{ position: "relative" }}>
        {(() => {
  let imagenUrl = producto.Img;

  if (!imagenUrl && producto.Visuales) {
    const visualesArray = Object.values(producto.Visuales)
      .filter((item) => item && item.tipo === "imagen")
      .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

    if (visualesArray.length > 0) {
      imagenUrl = visualesArray[0].url;
    }
  }

  return (
    <img
      src={imagenUrl || "images/default.jpg"}
      alt={producto.Titulo || "Producto"}
      style={{
        width: "100%",
        height: "180px",
        objectFit: "cover",
        borderRadius: "10%",
      }}
    />
  );
})()}


          {/* Etiqueta de descuento */}
          {tienePrecioAnterior && (
            <div
              style={{
                position: "absolute",
                bottom: "8px",
                left: "8px",
                backgroundColor: "#b016b5",
                color: "white",
                padding: "4px 8px",
                borderRadius: "8px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              -{porcentajeDescuento}% OFF
            </div>
          )}
        </div>

        {/* Título */}
        <div
          style={{
            color: "black",
            fontWeight: "bold",
            marginTop: "10px",
            height: "38px",
          }}
        >
          {producto.Titulo || ""}
        </div>

        {/* Precio anterior con tachado */}
        {tienePrecioAnterior && (
          <div
            style={{
              color: "#7c7c7c",
              fontSize: "15px",
              fontWeight: "bold",
              textDecoration: "line-through", // ← tachado
            }}
          >
            ${producto.PrecioAnterior.toLocaleString("es-CO")}
          </div>
        )}

        {/* Precio actual */}
        <div
          style={{
            marginTop: "5px",
            backgroundColor: "#57a710",
            color: "white",
            padding: "5px",
            borderRadius: "10px",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          ${producto.Precio?.toLocaleString("es-CO") || "0"}
        </div>
      </div>
    );
  })}

          
        </div>
      </div>
    </div>



    



      </div>

    </div>

  </div>

 
</div>


    );
  }
  
  export default PantallaPrincipal;
  
